import React from "react";
import LearnMore from "../buttons/LearnMore";
import { FaHeadSideVirus } from "react-icons/fa6";

function Neurology() {
  return (
    <div>
      <div>
        <FaHeadSideVirus className='fill-primary' size={120} />
      </div>
      <h1 className='text-2xl sm:text-3xl text-black/70 my-7'>
        Neurology Department
      </h1>
      <p className='text-gray-500 w-[95%]'>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt
        voluptate, quibusdam sunt iste dolores consequatur
      </p>
      <p className='text-gray-500 w-[95%] my-4'>
        Inventore fugit error iure nisi reiciendis fugiat illo pariatur quam
        sequi quod iusto facilis officiis nobis sit quis molestias asperiores
        rem, blanditiis! Commodi exercitationem vitae deserunt qui nihil ea,
        tempore et quam natus quaerat doloremque.
      </p>
      <LearnMore />
    </div>
  );
}

export default Neurology;
